import { render } from "./exams-index.vue?vue&type=template&id=61d59a3f"
import script from "./exams-index.vue?vue&type=script&lang=js"
export * from "./exams-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__